module.exports = __webpack_public_path__ + "img/michelle-name.2b4a4931.png";